import { z } from 'zod';
import { ProcessStepRecordingSchema } from '../../entities/process-step-recording';
import { StepActionTypeSchema } from '../../shared/step-action-type.schema';
/**
 * PATCH /api/v2/process/:id/draft/steps/:stepId — request
 * All editable fields are optional so partial patches are allowed.
 * Steps are manual-only; assignee-only edits belong on the assignment endpoint.
 *
 * The response envelope carries the updated step plus every other draft node
 * touched by edit cascades (stale-rule pruning, successor recompute).
 */ const EditableDraftStepFields = ProcessStepRecordingSchema.pick({
    inputs: true,
    task: true,
    rules: true,
    assignedTo: true,
    assignedToModel: true,
    helpers: true,
    whoElseDoesThis: true,
    generatedName: true,
    generatedDescription: true
}).partial();
export const UpdateDraftStepRequestSchema = EditableDraftStepFields.extend({
    actionType: StepActionTypeSchema.optional(),
    // Draft-only re-survey flag (ADR 0009): staged here, applied on publish.
    resurveyRequested: z.boolean().optional()
});

//# sourceMappingURL=update-draft-step.schema.js.map